import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography, Grid, TextField, Button, Divider } from '@mui/material';
import DateRange from '@mui/icons-material/DateRange';  
import { FaMapMarkerAlt, FaEnvelope, FaPhone, FaIndustry, FaMap, FaBuilding, FaUserAlt} from 'react-icons/fa';
import {Add,Remove} from '@mui/icons-material';
import api from '../../Services/api';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import IconButton from '@mui/material/IconButton';




export const ClientProfile = () => {
    let data1 = sessionStorage.getItem('user');
let clientData = JSON.parse(data1);
let id = clientData.id;
console.log('assessor Id',id);
    const [editMode, setEditMode] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
              const [snackbarMessage, setSnackbarMessage] = useState('');
              const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
              const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
              const [errors, setErrors] = useState({});
  const [originalData, setOriginalData] = useState({});
  const [companyData, setCompanyData] = useState({ 

    principleEmployer: '',
    stateId: '',
    placeName: '',
    pinCode: '',
    companyAddress: '',
    authorisedPersonName: '',
    companyEmailId: '',
    companyPhoneNumber: '',
    companyEmailId1: '',
    companyPhoneNumber1: '',
    clientName: '',
    division:'',
    clientAddress: '',
    clientContactPersonName: '',
    clientContactPersonPhoneNumber: '',
    clientContactPersonEmailId: '',
    clientContactPersonPhoneNumber1: '',
    clientContactPersonEmailId1: '',
    clientUsername: '',
    clientPassword: '',
    startDate:'',
    endDate: '',
       

  });
    const [extraEmailClientVisible, setExtraEmailClientVisible] = useState(false);
    const [extraPhoneNumberClientVisible, setExtraPhoneNumberClientVisible] = useState(false);


  useEffect(() =>{
    api.client.getClient(id)
    .then(response =>{
      const temp = response.data.data;
      console.log("temp",temp);
      setCompanyData(temp);
      
      setOriginalData(temp);
    })
    .catch(error => console.error('error fetching profile data:', error))
  }, []);

   const handleAddPhoneNumberClientField = () => {
    setExtraPhoneNumberClientVisible(prevState =>!prevState);
  };
  const handleAddEmailCompanyField = () => {
    setExtraEmailClientVisible(prevState => !prevState);
  };

  const validateForm = () => {
    const newErrors = {};
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phonePattern = /^[6789]\d{9}$/;
    
    if (!companyData.clientContactPersonName) newErrors.clientContactPersonName = 'Contact person Name is required';


if (!companyData.clientContactPersonEmailId) {
  newErrors.clientContactPersonEmailId = 'Email address required';
} else {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailPattern.test(companyData.clientContactPersonEmailId)) {
    newErrors.clientContactPersonEmailId = 'Invalid email address (ex: text@email.com)';
  }
}


if (!companyData.clientContactPersonPhoneNumber) {
  newErrors.clientContactPersonPhoneNumber = 'Phone number required';
} else {

  const phonePattern = /^[6-9]\d{9}$/;
  if (!phonePattern.test(companyData.clientContactPersonPhoneNumber)) {
    newErrors.clientContactPersonPhoneNumber = 'Invalid phone number, Number should not start with zero(6-9)';
  }
  
  const phoneNumber = String(companyData.clientContactPersonPhoneNumber);
  if (phoneNumber.length !== 10 || !/^\d{10}$/.test(phoneNumber)) {
    newErrors.clientContactPersonPhoneNumber = 'Phone number should be exactly 10 digits';
  }
}


      if (companyData.clientContactPersonEmailId1 && !emailPattern.test(companyData.clientContactPersonEmailId1)) {
        newErrors.clientContactPersonEmailId1 = 'Invalid email address (e.g., text@email.com)';
      }
     
      if (companyData.clientContactPersonPhoneNumber1 && !phonePattern.test(companyData.clientContactPersonPhoneNumber1)) {
        newErrors.clientContactPersonPhoneNumber1 = 'Invalid phone number. Number should not start with zero(6-9) and length should be 10';
      }

      setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
}
  



 

  const handleEdit = () => {
    setOriginalData({...companyData});
    setEditMode(true);
  };

  const handleCancelEdit = () => {
    setEditMode(false);
    setCompanyData({...originalData});
    setErrors({})
   
  };

  
 
  const handleSave = async()=>{
    const isDataChanged = JSON.stringify(companyData) !== JSON.stringify(originalData);

    if (!isDataChanged) {
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage("No changes detected");
      setEditMode(true); 
      return; 
    }
    if(validateForm()){
    try{
    const response = await api.client.editClient( id , companyData)
  
      if(response.status === 200){
        setSnackbarOpen(true)
        setSnackbarMessage(response.data.message)
              setOriginalData({ ...companyData });
              setEditMode(false);
            }
            else if(response.status === 400){
             setSnackbarOpen(true);
             setErrorSnackbarOpen(response.data.message)
            }
            else if(response.status === 500){
                setSnackbarOpen(true);
                setErrorSnackbarOpen(response.data.message)
               }
               else {
                setSnackbarOpen(true);
                setErrorSnackbarOpen("Error in updating, try again")
                setEditMode(false)
               }
    }
  

    catch(error) {
     setErrorSnackbarOpen(true);
     setSnackbarErrorMessage("Error Occured while updating")
    };
  }
  };
 

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCompanyData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  return (
    <>
      <Snackbar
                          anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                          
                          }}
                          severity="success"
                          open={snackbarOpen}
                          autoHideDuration={2000}
                          onClose={() => setSnackbarOpen(false)}
                          sx={{
                            marginTop: '2.9%', 
                            marginRight: '7%'
                          }}
                        >
                          <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
                        </Snackbar>
                        <Snackbar
                          anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                          }}
                          severity="error"
                          open={errorSnackbarOpen}
                          autoHideDuration={2000}
                          sx={{
                            marginTop: '2.9%', 
                            marginRight: '7%'
                          }}
                          onClose={() => {setErrorSnackbarOpen(false)}}
                        >
                          <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
                        </Snackbar>
    <div className="mt-3 d-flex justify-content-center align-items-center">
  <Card className="w-50 justify-content-center align-items-center">
    <div className="text-dark p-2 bg-light justify-content-center align-items-center" style={{border:'1px solid lightgray'}}>
    <h5>{companyData.clientName}, {companyData.clientAddress}
       </h5>
       <h6 className="fw-bold">{companyData.division}</h6>
       </div>
    <section className="d-flex flex-row">
    
      {/* Left Section (Client Details) */}
      <div className="px-3 pt-2 pb-4">
        <Typography className="mt-2 text-dark" variant="body2" component="div">
          <FaBuilding /> Principal Employer : {companyData?.principleEmployer}
        </Typography>
        <Typography className="mt-2 text-dark" variant="body2" component="div">
          <FaMapMarkerAlt /> Address : {companyData?.companyAddress}, {companyData?.placeName} {companyData?.stateId} - {companyData?.pinCode}
        </Typography>
        <Typography className="mt-2 text-dark" variant="body2" component="div">
          <FaUserAlt /> Authorised Person : {companyData?.authorisedPersonName}
        </Typography>
        <Typography className="mt-2 text-dark" variant="body2" component="div">
          <FaPhone /> Contact Number : {companyData?.companyPhoneNumber} {companyData?.companyPhoneNumber1 && `, ${companyData?.companyPhoneNumber1}`}
        </Typography>
        <Typography className="mt-2 text-dark" variant="body2" component="div">
          <FaEnvelope /> Email : {companyData?.companyEmailId} {companyData?.companyEmailId1 && `, ${companyData?.companyEmailId1}`}
        </Typography>
        <Typography className="mt-2 text-dark" variant="body2" component="div">
          <DateRange /> Contract Start Date : {companyData?.startDate.slice(0, 10).split('-').reverse().join('-')}
        </Typography>
        <Typography className="mt-2 text-dark" variant="body2" component="div">
          <DateRange /> Contract End Date : {companyData?.endDate.slice(0, 10).split('-').reverse().join('-')}
        </Typography>
      </div>
    
      {/* Right Section (Edit/Save and Contact Person Details) */}
      
      <div className="p-4 bg-dark" style={{width:'500px'}}>
      <h5 className="text-light" style={{borderBottom:'1px solid lightgray'}}>Conatct Person Details</h5>
        <div>
          <Typography variant="body3" className="mt-3 text-white" component="div">
            {editMode ? (
              <TextField
                type="text"
                name="clientContactPersonName"
                value={companyData?.clientContactPersonName}
                onChange={handleInputChange}
                 placeholder='Enter Contact Person Name'
                variant="outlined"
                size="small"
                inputProps={{ style: { color: '#000000' } }}
                style={{ backgroundColor: "white" }}
                error={!!errors.clientContactPersonName}
                helperText={errors.clientContactPersonName}
              />
            ) : (
              companyData?.clientContactPersonName
            )}
          </Typography>
  
          <Typography variant="body3" className="mt-3 text-white d-flex" component="div">
            {editMode ? (
              <TextField
                type="text"
                name="clientContactPersonPhoneNumber"
                value={companyData?.clientContactPersonPhoneNumber}
                onChange={handleInputChange}
                 placeholder='Enter Contact Number'
                variant="outlined"
                size="small"
                inputProps={{ style: { color: '#000000' } }}
                style={{ backgroundColor: "white" }}
                error={!!errors.clientContactPersonPhoneNumber}
                helperText={errors.clientContactPersonPhoneNumber}
              />
            ) : (
              companyData?.clientContactPersonPhoneNumber
            )}
             <IconButton onClick={handleAddPhoneNumberClientField} color="primary">
              {extraPhoneNumberClientVisible ? <Remove sx={{ color: "#eeee",fontSize:'16px' }} /> : <Add sx={{ color: "#eeee",fontSize:'16px' }} />}
          </IconButton>



          
          </Typography>
          {extraPhoneNumberClientVisible && (
  
  <Typography variant="body3" className="mt-1 text-white" component="div">
                      {editMode ? (
              <TextField
                type="text"
                name="clientContactPersonPhoneNumber1"
                value={companyData?.clientContactPersonPhoneNumber1}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
                 placeholder='Enter Alternative Contcat Number'
                inputProps={{ style: { color: '#000000' } }}
                style={{ backgroundColor: "white" }}
                error={!!errors.clientContactPersonPhoneNumber1}
                helperText={errors.clientContactPersonPhoneNumber1}
              />
            ) : (
              companyData?.clientContactPersonPhoneNumber1
            )}
                    </Typography>
                  )}
  
          <Typography variant="body3" className="mt-3 text-white d-flex" component="div">
            {editMode ? (
              <TextField
                type="text"
                name="clientContactPersonEmailId"
                  placeholder="Enter Email"
                value={companyData?.clientContactPersonEmailId}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
                inputProps={{ style: { color: '#000000' } }}
                style={{ backgroundColor: "white" }}
                error={!!errors.clientContactPersonEmailId}
                helperText={errors.clientContactPersonEmailId}
              />
            ) : (
              companyData?.clientContactPersonEmailId
            )}
             <IconButton onClick={handleAddEmailCompanyField}  color="primary">
            {extraEmailClientVisible ? <Remove sx={{ color: "#eeee",fontSize:'16px'  }} /> : <Add sx={{ color: "#eeee" ,fontSize:'16px' }} />}
          </IconButton> 
          </Typography>
          {extraEmailClientVisible && (
  
  <Typography variant="body3" className=" mt-1 text-white" component="div">
                      {editMode ? (
              <TextField
                type="text"
                name="clientContactPersonEmailId1"
                  placeholder="Enter Alternative Email"
                value={companyData?.clientContactPersonEmailId1}
                onChange={handleInputChange}
                variant="outlined"
                size="small"
                inputProps={{ style: { color: '#000000' } }}
                style={{ backgroundColor: "white" }}
                error={!!errors.clientContactPersonEmailId1}
                helperText={errors.clientContactPersonEmailId1}
              />
            ) : (
              companyData?.clientContactPersonEmailId1
            )}
                    </Typography>
                  )}
        </div>
   
        {/* Edit and Save Buttons */}
        {editMode ? (
          <div className="mt-3 pb-3 text-center">
            <button onClick={handleCancelEdit} className="mx-3 btn btn-sm btn-danger">
              Cancel
            </button>
            <button onClick={handleSave} className="mx-2  btn btn-sm btn-success" disabled={!validateForm}>
              Save
            </button>
          </div>
        ) : (
          <div className="mt-2 d-flex float-end">
            <button onClick={handleEdit} className="btn btn-sm btn-danger" >
Edit
            </button>
          </div>
        )}
      </div>
    </section>
  </Card>
</div>
</>

  )
}
